<template>
    <div class="shop-info-page">
        <h2 class="page-title">店铺信息</h2>
        <div class="info-section">
            <!-- 认证成功提示弹窗（自动消失） -->
            <div class="success-toast" v-if="showSuccessToast">
                <div class="toast-content">
                    <i class="success-icon">✓</i>
                    <span class="success-text">{{ successMessage }}</span>
                </div>
            </div>

            <!-- 权属声明弹窗 -->
            <div class="declaration-modal" v-if="showDeclarationModal">
                <div class="modal-content">
                    <div class="modal-title">智步云上模型网权属声明</div>
                    <div class="modal-body">
                        <p>智步云上模型网用户名：{{ accountNickname }}</p>
                        <p>企业名称：{{ formData.enterpriseName || '待填写' }}</p>
                        <p>统一社会信用代码：{{ formData.usci || '待填写' }}</p>
                        <p>法人名称：{{ formData.legalPersonName || '待填写' }}</p>
                        <p>法人身份证号码：{{ formData.legalPersonIDNumber ? maskidCard(formData.legalPersonIDNumber) : '待填写' }}
                        </p>
                        <br>
                        <p>本企业是智步云上模型网实名认证商户，本企业已完全阅读、充分理解并自愿接受智步云上模型网的各项协议及规则,现就本企业于智步云上模型网所发布的作品，特作如下声明：</p>
                        <br>
                        <p>1、本企业在智步云上模型网上传的所有作品均系本企业的原创作品或已经取得作品权利人完整、合法授权的授权作品，不存在任何权属纠纷；</p>
                        <br>
                        <p>2、因本企业上传、展示的作品侵权产生的法律责任及经济损失全部由本企业承担，相关责任的追究将以本企业在智步云上模型网实名签约的信息为准；</p>
                        <br>
                        <p>3、本企业将作品上传至智步云上模型网即视为同意用户通过网站规定付费后获得指定的授权许可，具体授权类型以网站界面显示为准；</p>
                        <br>
                        <p>4、本企业对本声明之前上传在智步云上模型网的所有作品承担本声明中同等的法律责任并予以同等的授权许可；</p>
                        <br>
                        <p>5、本企业承诺上传至智步云上模型网的作品权属声明与此原件内容完全一致，是本企业的真实意思表示。</p>
                    </div>
                    <div class="modal-footer">
                        <button class="agree-btn" @click="confirmDeclaration" :disabled="!isAgreeBtnEnabled">
                            我同意<span v-if="countDown > 0">（{{ countDown > 0 ? countDown : '0' }}秒后可点击）</span>
                        </button>
                    </div>
                </div>
            </div>

            <!-- 拖拽验证码弹窗 -->
            <div class="verify-modal" v-if="showVerifyModal" @click.self="closeVerifyModal">
                <div class="verify-modal-content">
                    <h3 class="verify-title">安全验证</h3>
                    <div class="drag-verify-container" ref="verifyContainer">
                        <canvas ref="canvas" class="verify-canvas" @mousedown.prevent @touchstart.prevent></canvas>
                        <div class="drag-slider" ref="slider" :style="{ left: sliderLeft + 'px' }"
                            @mousedown="startDrag" @touchstart="startDrag">
                            <i class="el-icon-right"></i>
                        </div>
                        <div class="verify-tip" :class="{ success: verifySuccess, error: verifyError }">
                            {{ tipText }}
                        </div>
                        <div class="slider-track">
                            <div class="track-bg"></div>
                        </div>
                    </div>
                    <div class="verify-footer">
                        <button class="close-verify-btn" @click="closeVerifyModal">取消</button>
                        <button class="refresh-btn" @click="refreshVerify" :disabled="isDragging">
                            刷新验证
                        </button>
                    </div>
                </div>
            </div>

            <!-- 修改开票状态弹窗 -->
            <div class="invoice-modal" v-if="showInvoiceModal" @click.self="closeInvoiceModal">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3>修改开票设置</h3>
                        <button class="close-btn" @click="closeInvoiceModal">×</button>
                    </div>
                    <div class="modal-body">
                        <div class="radio-group">
                            <label class="radio-label">
                                <input type="radio" v-model="editInvoiceStatus" value="true">
                                <span>支持开发票</span>
                            </label>
                            <label class="radio-label">
                                <input type="radio" v-model="editInvoiceStatus" value="false">
                                <span>不支持开发票</span>
                            </label>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="cancel-btn" @click="closeInvoiceModal">取消</button>
                        <button class="confirm-btn" @click="confirmEditInvoice" :disabled="!hasInvoiceChanged">
                            确认修改
                        </button>
                    </div>
                </div>
            </div>

            <!-- 加载状态 -->
            <div class="loading-container" v-if="isLoading">
                <div class="loading-spinner"></div>
                <span class="loading-text">正在处理中...</span>
            </div>

            <!-- 审核中卡片 -->
            <div class="review-card" v-if="isReviewing && !isLoading" transition="fade">
                <div class="card-header">
                    <div class="card-title">企业认证审核中</div>
                    <div class="review-status">待审核</div>
                </div>
                <div class="card-body">
                    <div class="auth-item">
                        <span class="label">企业名称：</span>
                        <span class="value">{{ formData.enterpriseName || '未知' }}</span>
                    </div>
                    <div class="auth-item">
                        <span class="label">统一社会信用代码：</span>
                        <span class="value">{{ formData.usci || '未知' }}</span>
                    </div>
                    <div class="auth-item">
                        <span class="label">法人名称：</span>
                        <span class="value">{{ formData.legalPersonName || '未知' }}</span>
                    </div>
                    <div class="auth-item">
                        <span class="label">法人身份证号：</span>
                        <span class="value">{{ maskidCard(formData.legalPersonIDNumber) }}</span>
                    </div>
                    <div class="auth-item">
                        <span class="label">审核状态：</span>
                        <span class="value review-text">资料已提交，工作人员正在审核中，请耐心等待...</span>
                    </div>
                </div>
            </div>

            <!-- 企业认证成功信息展示区 -->
            <div class="auth-card" v-else-if="isVerified && !isLoading" transition="fade">
                <div class="card-header">
                    <div class="card-title">企业认证成功</div>
                </div>
                <div class="card-body">
                    <div class="auth-item">
                        <span class="label">企业名称：</span>
                        <span class="value">{{ formData.enterpriseName || '未知' }}</span>
                    </div>
                    <div class="auth-item">
                        <span class="label">统一社会信用代码：</span>
                        <span class="value">{{ formData.usci || '未知' }}</span>
                    </div>
                    <div class="auth-item">
                        <span class="label">法人名称：</span>
                        <span class="value">{{ formData.legalPersonName || '未知' }}</span>
                    </div>
                    <div class="auth-item">
                        <span class="label">法人身份证号：</span>
                        <span class="value">{{ maskidCard(formData.legalPersonIDNumber) }}</span>
                    </div>
                    <div class="auth-item">
                        <span class="label">是否支持开票：</span>
                        <span class="value" :class="{
                            'success-text': whetherInvoice === true,
                            'error-text': whetherInvoice === false,
                            'loading-text': whetherInvoice === 'loading'
                        }">
                            {{
                                whetherInvoice === 'loading'
                                    ? '查询中...'
                                    : (whetherInvoice ? '支持开发票' : '不支持开发票')
                            }}
                        </span>
                        <span class="edit-invoice-text" @click="whetherInvoice !== 'loading' && openInvoiceModal()"
                            :class="{ disabled: whetherInvoice === 'loading' }">
                            修改
                        </span>
                    </div>
                </div>
            </div>

            <!-- 企业认证表单区（仅未认证、未审核时显示） -->
            <div class="auth-form-card" v-else-if="!isLoading && !isReviewing">
                <div class="form-header">
                    <div class="form-title">企业认证</div>
                    <div class="form-desc">请完成企业认证以开启店铺功能，认证信息仅用于身份核实</div>
                </div>

                <form class="auth-form" @submit.prevent="handleSubmitWithVerify">
                    <div class="form-group">
                        <label class="form-label">企业名称 <span class="required">*</span></label>
                        <input type="text" class="form-input" placeholder="请输入企业名称" v-model="formData.enterpriseName"
                            :disabled="isSubmitting">
                        <div class="error-tip" v-if="errors.enterpriseName">{{ errors.enterpriseName }}</div>
                    </div>

                    <!-- 统一社会信用代码 -->
                    <div class="form-group">
                        <label class="form-label">统一社会信用代码 <span class="required">*</span></label>
                        <input type="text" class="form-input" placeholder="请输入18位统一社会信用代码" v-model="formData.usci"
                            :disabled="isSubmitting" maxlength="18">
                        <div class="error-tip" v-if="errors.usci">{{ errors.usci }}</div>
                    </div>

                    <div class="form-group">
                        <label class="form-label">法人名称 <span class="required">*</span></label>
                        <input type="text" class="form-input" placeholder="请输入法人姓名" v-model="formData.legalPersonName"
                            :disabled="isSubmitting">
                        <div class="error-tip" v-if="errors.legalPersonName">{{ errors.legalPersonName }}</div>
                    </div>

                    <div class="form-group">
                        <label class="form-label">法人身份证号 <span class="required">*</span></label>
                        <input type="text" class="form-input" placeholder="请输入法人身份证号码"
                            v-model="formData.legalPersonIDNumber" :disabled="isSubmitting">
                        <div class="error-tip" v-if="errors.legalPersonIDNumber">{{ errors.legalPersonIDNumber }}</div>
                    </div>

                    <!-- 营业执照上传 -->
                    <div class="form-group">
                        <label class="form-label">营业执照 <span class="required">*</span></label>
                        <div class="upload-box">
                            <input type="file" id="license" accept="image/*"
                                @change="uploadImage($event, 'businessLicense')" :disabled="isSubmitting">
                            <label for="license" class="upload-btn">
                                <span v-if="!formData.businessLicense">点击上传营业执照</span>
                                <span v-else class="upload-success">上传成功</span>
                            </label>
                        </div>
                        <div class="error-tip" v-if="errors.businessLicense">{{ errors.businessLicense }}</div>
                    </div>

                    <!-- 法人身份证正面 -->
                    <div class="form-group">
                        <label class="form-label">法人身份证正面 <span class="required">*</span></label>
                        <div class="upload-box">
                            <input type="file" id="front" accept="image/*" @change="uploadImage($event, 'frontImage')"
                                :disabled="isSubmitting">
                            <label for="front" class="upload-btn">
                                <span v-if="!formData.frontImage">点击上传身份证正面</span>
                                <span v-else class="upload-success">上传成功</span>
                            </label>
                        </div>
                        <div class="error-tip" v-if="errors.frontImage">{{ errors.frontImage }}</div>
                    </div>

                    <!-- 法人身份证反面 -->
                    <div class="form-group">
                        <label class="form-label">法人身份证反面 <span class="required">*</span></label>
                        <div class="upload-box">
                            <input type="file" id="reverse" accept="image/*"
                                @change="uploadImage($event, 'reverseImage')" :disabled="isSubmitting">
                            <label for="reverse" class="upload-btn">
                                <span v-if="!formData.reverseImage">点击上传身份证反面</span>
                                <span v-else class="upload-success">上传成功</span>
                            </label>
                        </div>
                        <div class="error-tip" v-if="errors.reverseImage">{{ errors.reverseImage }}</div>
                    </div>

                    <!-- 是否支持开发票单选框 -->
                    <div class="form-group">
                        <label class="form-label">是否支持开发票 <span class="required">*</span></label>
                        <div class="radio-group">
                            <label class="radio-label">
                                <input type="radio" v-model="whetherInvoice" :value="true" :disabled="isSubmitting">
                                <span>支持</span>
                            </label>
                            <label class="radio-label">
                                <input type="radio" v-model="whetherInvoice" :value="false" :disabled="isSubmitting">
                                <span>不支持</span>
                            </label>
                        </div>
                        <div class="error-tip" v-if="errors.invoice">{{ errors.invoice }}</div>
                    </div>

                    <!-- 权属声明勾选框 -->
                    <div class="form-group agreement-group">
                        <div class="agreement-wrapper">
                            <input type="checkbox" v-model="isAgreeDeclaration" :disabled="isSubmitting"
                                @click="handleCheckboxClick" class="agreement-checkbox">
                            <span class="agreement-text" @click="handleTextClick">我已阅读并同意</span>
                            <a href="javascript:;" class="agreement-link" @click="handleLinkClick">《权属协议》</a>
                        </div>
                        <div class="error-tip" v-if="errors.agreement">{{ errors.agreement }}</div>
                    </div>

                    <div class="form-actions">
                        <button type="submit" class="btn-submit" :disabled="isSubmitting || !isAgreeDeclaration">
                            <span v-if="!isSubmitting">提交企业认证</span>
                            <span v-if="isSubmitting">提交中...</span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ShopInfoPage',
    data() {
        return {
            isVerified: false,
            isReviewing: false,
            reviewStatus: false,
            isLoading: true,
            isSubmitting: false,
            showSuccessToast: false,
            successMessage: '',
            authTime: '',

            // 企业认证表单字段
            formData: {
                enterpriseName: '',        // 企业名称
                usci: '',                  // 统一社会信用代码
                legalPersonName: '',        // 法人名称
                legalPersonIDNumber: '',    // 法人身份证号
                businessLicense: '',        // 营业执照图片URL
                frontImage: '',             // 身份证正面URL
                reverseImage: ''            // 身份证反面URL
            },

            errors: {},

            isAgreeDeclaration: false,
            showDeclarationModal: false,
            accountNickname: '',
            countDown: 5,
            isAgreeBtnEnabled: false,
            timer: null,

            isLoggedIn: false,
            defaultAvatar: '',
            userName: '',

            // 拖拽验证
            showVerifyModal: false,
            canvas: null,
            ctx: null,
            canvasWidth: 320,
            canvasHeight: 160,
            gapWidth: 40,
            gapHeight: 40,
            gapX: 0,
            sliderLeft: 0,
            startX: 0,
            containerLeft: 0,
            verifySuccess: false,
            verifyError: false,
            tipText: '请拖动滑块完成验证',
            verifyToken: '',
            isDragging: false,
            sliderPattern: null,
            sliderPatternX: 0,
            sliderPatternY: 0,
            originalImageData: null,

            // 发票相关状态
            whetherInvoice: 'loading',
            showInvoiceModal: false,
            editInvoiceStatus: null,
            originalInvoiceStatus: null,
        }
    },
    async mounted() {
        try {
            await Promise.all([
                this.getUserInt(),
                this.checkAuthStatus()
            ]);
            if (this.isVerified) {
                await this.getInvoiceStatus();
            }
        } catch (err) {
            console.error('页面初始化出错：', err);
            this.isLoading = false;
        }
    },
    computed: {
        hasInvoiceChanged() {
            return this.editInvoiceStatus !== this.originalInvoiceStatus;
        }
    },
    beforeDestroy() {
        if (this.timer) clearInterval(this.timer);
        this.removeDragEvents();
    },
    methods: {
        async getUserInt() {
            try {
                const res = await this.$apiFun.getUserInt();
                if (res.status === 200) {
                    this.accountNickname = res.obj.userName;
                    this.isLoggedIn = true;
                } else if (res.status === 401) {
                    this.defaultAvatar = '';
                    this.userName = '';
                    this.isLoggedIn = false;
                }
            } catch (err) {
                console.error('获取用户信息出错：', err);
            }
        },

        // 查询企业认证状态
        async checkAuthStatus() {
            this.isLoading = true;
            this.isReviewing = false;
            this.isVerified = false;

            try {
                const res = await this.$apiFun.getSeCertification();
                if (res.status === 200 && res.obj) {
                    const data = res.obj;
                    this.reviewStatus = data.reviewStatus;

                    // 判断关键字段是否都有值
                    // const hasInfo = !!data.enterpriseName && !!data.legalPersonIDNumber && !!data.legalPersonName;
                    const hasInfo = !!data.enterpriseName && !!data.usci && !!data.legalPersonIDNumber && !!data.legalPersonName;

                    if (hasInfo) {
                        // 赋值信息
                        this.formData = {
                            enterpriseName: data.enterpriseName || '',
                            usci: data.usci || '',
                            legalPersonName: data.legalPersonName || '',
                            legalPersonIDNumber: data.legalPersonIDNumber || '',
                            businessLicense: data.businessLicense || '',
                            frontImage: data.frontImage || '',
                            reverseImage: data.reverseImage || ''
                        };

                        // 审核中：信息完整 + reviewStatus = false
                        if (data.reviewStatus === false) {
                            this.isReviewing = true;
                            this.isVerified = false;
                        }
                        // 认证成功：信息完整 + reviewStatus = true
                        else if (data.reviewStatus === true) {
                            this.isReviewing = false;
                            this.isVerified = true;
                            this.authTime = new Date().toLocaleString();
                        }
                    } else {
                        // 未认证
                        this.isReviewing = false;
                        this.isVerified = false;
                    }
                } else {
                    this.$message.error("企业认证状态查询失败");
                    this.isReviewing = false;
                    this.isVerified = false;
                }
            } catch (err) {
                this.$message.error('企业认证状态查询失败');
                console.error('查询认证状态出错：', err);
                this.isReviewing = false;
                this.isVerified = false;
            } finally {
                this.isLoading = false;
            }
        },

        // 图片上传方法
        async uploadImage(event, field) {
            const file = event.target.files[0];
            if (!file) return;

            this.isSubmitting = true;
            try {
                const formData = new FormData();
                formData.append('file', file);

                const res = await this.$apiFun.postUploadFile(formData);
                if (res.status === 200 && res.obj.fileUrl) {
                    this.formData[field] = res.obj.fileUrl;
                    this.$message.success('图片上传成功');
                } else {
                    this.$message.error('图片上传失败');
                }
            } catch (err) {
                console.error('图片上传失败：', err);
                this.$message.error('图片上传失败，请重试');
            } finally {
                this.isSubmitting = false;
            }
        },

        // 查询开票状态
        async getInvoiceStatus() {
            try {
                const res = await this.$apiFun.getSeInvoice();
                if (res.status === 200) {
                    this.whetherInvoice = res.obj.whetherInvoice;
                } else {
                    this.$message.error('查询开票状态失败');
                    this.whetherInvoice = false;
                }
            } catch (err) {
                console.error('查询开票状态失败：', err);
                this.$message.error('查询开票状态失败');
                this.whetherInvoice = false;
            }
        },

        // 修改开票状态
        async updateInvoiceStatus(status) {
            try {
                const res = await this.$apiFun.postUpInvoice({ whetherInvoice: status });
                if (res.status === 200) {
                    return true;
                } else {
                    this.$message.error(res.msg || '设置开票状态失败');
                    return false;
                }
            } catch (err) {
                console.error('设置开票状态失败：', err);
                this.$message.error('设置开票状态失败');
                return false;
            }
        },

        // 打开修改开票弹窗
        openInvoiceModal() {
            this.originalInvoiceStatus = String(this.whetherInvoice);
            this.editInvoiceStatus = this.originalInvoiceStatus;
            this.showInvoiceModal = true;
        },

        // 关闭修改开票弹窗
        closeInvoiceModal() {
            this.showInvoiceModal = false;
            this.editInvoiceStatus = null;
            this.originalInvoiceStatus = null;
        },

        // 确认修改开票状态
        async confirmEditInvoice() {
            if (!this.hasInvoiceChanged) return;

            const newStatus = this.editInvoiceStatus === 'true';
            const success = await this.updateInvoiceStatus(newStatus);

            if (success) {
                this.whetherInvoice = newStatus;
                this.$message.success('修改成功');
                this.closeInvoiceModal();
            }
        },

        // 企业认证表单验证
        validateForm() {
            const errors = {};
            if (!this.formData.enterpriseName.trim()) {
                errors.enterpriseName = '请输入企业名称';
            }
            if (!this.formData.usci.trim()) {
                errors.usci = '请输入统一社会信用代码';
            } else if (this.formData.usci.length !== 18) {
                errors.usci = '统一社会信用代码必须为18位';
            }
            if (!this.formData.legalPersonName.trim()) {
                errors.legalPersonName = '请输入法人名称';
            }
            if (!this.formData.legalPersonIDNumber.trim()) {
                errors.legalPersonIDNumber = '请输入法人身份证号';
            } else {
                const idCardReg = /^\d{17}[\dXx]$/;
                if (!idCardReg.test(this.formData.legalPersonIDNumber)) {
                    errors.legalPersonIDNumber = '请输入有效的18位身份证号码';
                }
            }
            if (!this.formData.businessLicense) {
                errors.businessLicense = '请上传营业执照图片';
            }
            if (!this.formData.frontImage) {
                errors.frontImage = '请上传法人身份证正面图片';
            }
            if (!this.formData.reverseImage) {
                errors.reverseImage = '请上传法人身份证反面图片';
            }
            if (this.whetherInvoice === null || this.whetherInvoice === undefined) {
                errors.invoice = '请选择是否支持开发票';
            }
            if (!this.isAgreeDeclaration) {
                errors.agreement = '请阅读并同意《权属协议》';
            }

            this.errors = errors;
            return Object.keys(errors).length === 0;
        },

        // 简化验证（仅信息）
        validateForm2() {
            const errors = {};
            if (!this.formData.enterpriseName.trim()) {
                errors.enterpriseName = '请输入企业名称';
            }
            if (!this.formData.usci.trim()) {
                errors.usci = '请输入统一社会信用代码';
            }
            if (!this.formData.legalPersonName.trim()) {
                errors.legalPersonName = '请输入法人名称';
            }
            if (!this.formData.legalPersonIDNumber.trim()) {
                errors.legalPersonIDNumber = '请输入法人身份证号';
            }
            this.errors = errors;
            return Object.keys(errors).length === 0;
        },

        async handleSubmitWithVerify() {
            if (!this.validateForm()) return;
            this.showVerifyModal = true;
            this.$nextTick(() => {
                this.initCanvas();
            });
        },

        // 提交企业认证
        async submitForm() {
            this.isSubmitting = true;
            const submitData = {
                ...this.formData,
                isAgreeDeclaration: this.isAgreeDeclaration,
                verifyToken: this.verifyToken
            };

            try {
                const res = await this.$apiFun.postUpCertification(submitData);
                if (res.status === 200) {
                    // 设置开票状态
                    await this.updateInvoiceStatus(this.whetherInvoice);

                    // 提交后进入审核，不是直接成功
                    this.successMessage = '企业认证提交成功，等待管理员审核！';
                    this.showSuccessToast = true;

                    // 重新查询状态，显示审核中
                    await this.checkAuthStatus();

                    setTimeout(() => {
                        this.showSuccessToast = false;
                    }, 3000);
                } else {
                    this.$message.error(res.msg || '企业认证提交失败，请重试');
                }
            } catch (err) {
                this.$message.error('企业认证提交失败，网络异常');
                console.error('提交认证出错：', err);
            } finally {
                this.isSubmitting = false;
                this.showVerifyModal = false;
            }
        },

        // 身份证脱敏
        maskidCard(id) {
            if (!id) return '';
            return id.replace(/^(\d{6})\d+(\d{4})$/, '$1********$2');
        },

        // 勾选框点击
        handleCheckboxClick(e) {
            const isValid = this.validateForm2();
            if (!isValid) {
                e.preventDefault();
                return;
            }

            if (this.isAgreeDeclaration) {
                this.isAgreeDeclaration = false;
            } else {
                this.openDeclarationModalWithCountdown();
                e.preventDefault();
            }
        },

        // 文字点击
        handleTextClick() {
            const isValid = this.validateForm2();
            if (!isValid) return;

            if (this.isAgreeDeclaration) {
                this.isAgreeDeclaration = false;
            } else {
                this.openDeclarationModalWithCountdown();
            }
        },

        // 链接点击
        handleLinkClick(e) {
            e.stopPropagation();
            const isValid = this.validateForm2();
            if (!isValid) return;

            if (this.isAgreeDeclaration) {
                this.openDeclarationModalForView();
            } else {
                this.openDeclarationModalWithCountdown();
            }
        },

        // 带倒计时
        openDeclarationModalWithCountdown() {
            this.showDeclarationModal = true;
            this.countDown = 5;
            this.isAgreeBtnEnabled = false;

            if (this.timer) clearInterval(this.timer);
            this.timer = setInterval(() => {
                this.countDown--;
                if (this.countDown <= 0) {
                    clearInterval(this.timer);
                    this.isAgreeBtnEnabled = true;
                }
            }, 1000);
        },

        // 查看协议
        openDeclarationModalForView() {
            this.showDeclarationModal = true;
            this.countDown = 0;
            this.isAgreeBtnEnabled = true;
            if (this.timer) clearInterval(this.timer);
        },

        // 确认同意
        confirmDeclaration() {
            this.showDeclarationModal = false;
            this.isAgreeDeclaration = true;
            this.isAgreeBtnEnabled = false;
            if (this.timer) clearInterval(this.timer);
        },

        // ====================== 拖拽验证码 ======================
        initCanvas() {
            this.canvas = this.$refs.canvas;
            if (!this.canvas) return;
            this.ctx = this.canvas.getContext('2d');
            this.canvas.width = this.canvasWidth;
            this.canvas.height = this.canvasHeight;
            this.canvas.style.width = this.canvasWidth + 'px';
            this.canvas.style.height = this.canvasHeight + 'px';

            this.sliderLeft = 0;
            this.verifySuccess = false;
            this.verifyError = false;
            this.tipText = '请拖动滑块完成验证';
            this.isDragging = false;
            this.verifyToken = '';

            this.gapX = Math.floor(Math.random() * (this.canvasWidth - this.gapWidth * 3)) + this.gapWidth;
            this.sliderPatternX = this.gapX;
            this.sliderPatternY = (this.canvasHeight - this.gapHeight) / 2;
            this.drawCanvas();
        },

        drawCanvas() {
            if (!this.ctx) return;
            this.ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
            this.drawBackground();
            this.drawInterferenceLines();
            this.originalImageData = this.ctx.getImageData(0, 0, this.canvasWidth, this.canvasHeight);
            this.createGapInCanvas();
            this.saveSliderPattern();
            this.drawGapBorder();
        },

        drawBackground() {
            for (let y = 0; y < this.canvasHeight; y += 8) {
                for (let x = 0; x < this.canvasWidth; x += 8) {
                    this.ctx.fillStyle = (x + y) % 16 === 0 ? '#2a2a2a' : '#3a3a3a';
                    this.ctx.fillRect(x, y, 8, 8);
                }
            }
        },

        createGapInCanvas() {
            this.ctx.clearRect(
                this.sliderPatternX,
                this.sliderPatternY,
                this.gapWidth,
                this.gapHeight
            );
        },

        saveSliderPattern() {
            if (!this.ctx || !this.originalImageData) return;
            const sliderData = new ImageData(this.gapWidth, this.gapHeight);
            for (let y = 0; y < this.gapHeight; y++) {
                for (let x = 0; x < this.gapWidth; x++) {
                    const sourceX = this.sliderPatternX + x;
                    const sourceY = this.sliderPatternY + y;
                    const sourceIndex = (sourceY * this.canvasWidth + sourceX) * 4;
                    const targetIndex = (y * this.gapWidth + x) * 4;
                    sliderData.data[targetIndex] = this.originalImageData.data[sourceIndex];
                    sliderData.data[targetIndex + 1] = this.originalImageData.data[sourceIndex + 1];
                    sliderData.data[targetIndex + 2] = this.originalImageData.data[sourceIndex + 2];
                    sliderData.data[targetIndex + 3] = this.originalImageData.data[sourceIndex + 3];
                }
            }
            this.sliderPattern = sliderData;
        },

        drawGapBorder() {
            this.ctx.strokeStyle = '#0ea5e9';
            this.ctx.lineWidth = 2;
            this.ctx.strokeRect(
                this.sliderPatternX,
                this.sliderPatternY,
                this.gapWidth,
                this.gapHeight
            );
        },

        drawInterferenceLines() {
            for (let i = 0; i < 8; i++) {
                this.ctx.strokeStyle = `rgb(${Math.random() * 100 + 100}, ${Math.random() * 100 + 100}, ${Math.random() * 100 + 100})`;
                this.ctx.lineWidth = Math.random() * 2 + 0.5;
                this.ctx.beginPath();
                this.ctx.moveTo(Math.random() * this.canvasWidth, Math.random() * this.canvasHeight);
                this.ctx.lineTo(Math.random() * this.canvasWidth, Math.random() * this.canvasHeight);
                this.ctx.stroke();
            }
        },

        startDrag(e) {
            e.preventDefault();
            e.stopPropagation();
            if (this.verifySuccess || this.isDragging) return;
            this.isDragging = true;
            const container = this.$refs.verifyContainer;
            if (container) {
                const rect = container.getBoundingClientRect();
                this.containerLeft = rect.left;
            }
            const clientX = e.type === 'mousedown' ? e.clientX : e.touches[0].clientX;
            this.startX = clientX - this.containerLeft - this.sliderLeft;
            this.bindDragEvents();
        },

        bindDragEvents() {
            document.addEventListener('mousemove', this.handleDragMove);
            document.addEventListener('mouseup', this.handleDragEnd);
            document.addEventListener('touchmove', this.handleDragMove, { passive: false });
            document.addEventListener('touchend', this.handleDragEnd);
        },

        handleDragMove(e) {
            e.preventDefault();
            e.stopPropagation();
            if (!this.isDragging) return;
            const clientX = e.type === 'mousemove' ? e.clientX : e.touches[0].clientX;
            const offsetX = clientX - this.containerLeft - this.startX;
            this.sliderLeft = Math.max(0, Math.min(offsetX, this.canvasWidth - this.gapWidth));
            this.updateCanvasWithSlider();
        },

        updateCanvasWithSlider() {
            if (!this.ctx || !this.originalImageData) return;
            this.ctx.putImageData(this.originalImageData, 0, 0);
            this.ctx.clearRect(
                this.sliderPatternX,
                this.sliderPatternY,
                this.gapWidth,
                this.gapHeight
            );
            if (this.sliderPattern) {
                this.ctx.putImageData(
                    this.sliderPattern,
                    this.sliderLeft,
                    this.sliderPatternY
                );
                this.ctx.strokeStyle = '#0ea5e9';
                this.ctx.lineWidth = 2;
                this.ctx.strokeRect(
                    this.sliderLeft,
                    this.sliderPatternY,
                    this.gapWidth,
                    this.gapHeight
                );
            }
            this.drawGapBorder();
        },

        handleDragEnd(e) {
            e.preventDefault();
            e.stopPropagation();
            if (!this.isDragging) return;
            this.isDragging = false;
            this.removeDragEvents();
            const errorRange = 5;
            if (Math.abs(this.sliderLeft - this.gapX) <= errorRange) {
                this.verifySuccess = true;
                this.verifyError = false;
                this.tipText = '验证成功';
                this.verifyToken = this.generateVerifyToken();
                this.drawSuccessCanvas();
                setTimeout(() => {
                    this.submitForm();
                }, 500);
            } else {
                this.verifySuccess = false;
                this.verifyError = true;
                this.tipText = '验证失败，请重试';
                setTimeout(() => {
                    this.sliderLeft = 0;
                    this.initCanvas();
                }, 1000);
            }
        },

        removeDragEvents() {
            document.removeEventListener('mousemove', this.handleDragMove);
            document.removeEventListener('mouseup', this.handleDragEnd);
            document.removeEventListener('touchmove', this.handleDragMove);
            document.removeEventListener('touchend', this.handleDragEnd);
        },

        drawSuccessCanvas() {
            this.ctx.putImageData(this.originalImageData, 0, 0);
            this.ctx.strokeStyle = '#00b42a';
            this.ctx.lineWidth = 3;
            this.ctx.strokeRect(
                this.sliderPatternX,
                this.sliderPatternY,
                this.gapWidth,
                this.gapHeight
            );
            this.ctx.strokeRect(
                this.sliderLeft,
                this.sliderPatternY,
                this.gapWidth,
                this.gapHeight
            );
        },

        generateVerifyToken() {
            const timestamp = Date.now();
            const randomStr = Math.random().toString(36).substr(2, 10);
            return `${timestamp}_${randomStr}_${this.gapX}`;
        },

        refreshVerify() {
            if (this.isDragging) return;
            this.initCanvas();
        },

        closeVerifyModal() {
            this.showVerifyModal = false;
            this.removeDragEvents();
            this.sliderLeft = 0;
            this.verifySuccess = false;
            this.verifyError = false;
            this.isDragging = false;
            this.tipText = '请拖动滑块完成验证';
        },
    }
}
</script>

<style lang="less" scoped>
// 深色主题变量
@bg-primary: #1a1a1a;
@text-primary: #e0e0e0;
@text-secondary: #a0a0a0;
@accent-blue: #0ea5e9;
@accent-green: #38bdf8;
@accent-yellow: #f59e0b;
@accent-gray: #888;
@border-color: #444;
@card-bg: #111827;
@input-bg: transparent;
@error-color: #ff4d4f;
@modal-bg: rgba(0, 0, 0, 0.85);

.shop-info-page {
    color: @text-primary;
    padding: 20px;
    box-sizing: border-box;
    position: relative;

    // 发票修改弹窗
    .invoice-modal {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: @modal-bg;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1002;

        .modal-content {
            background: @card-bg;
            border-radius: 8px;
            width: 90%;
            max-width: 400px;
            overflow: hidden;

            .modal-header {
                padding: 16px;
                border-bottom: 1px solid @border-color;
                display: flex;
                justify-content: space-between;
                align-items: center;

                h3 {
                    margin: 0;
                    font-size: 16px;
                    color: @accent-blue;
                }

                .close-btn {
                    background: none;
                    border: none;
                    color: @text-primary;
                    font-size: 20px;
                    cursor: pointer;
                    padding: 0 8px;
                }
            }

            .modal-body {
                padding: 24px 16px;
            }

            .modal-footer {
                padding: 16px;
                border-top: 1px solid @border-color;
                display: flex;
                justify-content: flex-end;
                gap: 12px;
            }
        }

        .radio-group {
            display: flex;
            gap: 24px;
            justify-content: center;
        }

        .radio-label {
            display: flex;
            align-items: center;
            gap: 8px;
            cursor: pointer;
            font-size: 14px;

            input[type="radio"] {
                width: 16px;
                height: 16px;
                cursor: pointer;
            }
        }

        .cancel-btn,
        .confirm-btn {
            padding: 8px 16px;
            border-radius: 4px;
            cursor: pointer;
            font-size: 14px;
            border: none;
        }

        .cancel-btn {
            background: #444;
            color: @text-primary;
        }

        .confirm-btn {
            background: @accent-blue;
            color: white;

            &:disabled {
                background: #666;
                cursor: not-allowed;
                opacity: 0.7;
            }
        }
    }

    // 权属声明弹窗
    .declaration-modal {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: @modal-bg;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1000;

        .modal-content {
            background-color: @card-bg;
            border-radius: 8px;
            width: 80%;
            max-width: 800px;
            max-height: 90vh;
            overflow-y: auto;
            padding: 20px;

            .modal-title {
                font-size: 18px;
                font-weight: 60;
                color: @accent-blue;
                margin-bottom: 15px;
                border-bottom: 1px solid @border-color;
                padding-bottom: 10px;
            }

            .modal-body {
                font-size: 14px;
                line-height: 1.8;
                color: @text-primary;

                p {
                    margin: 0 0 8px 0;
                }
            }

            .modal-footer {
                margin-top: 20px;
                display: flex;
                justify-content: flex-end;

                .agree-btn {
                    padding: 10px 24px;
                    background-color: @accent-blue;
                    color: white;
                    border: none;
                    border-radius: 4px;
                    cursor: pointer;
                    font-size: 14px;

                    &:disabled {
                        background-color: #666;
                        cursor: not-allowed;
                    }
                }
            }
        }
    }

    // 拖拽验证码弹窗
    .verify-modal {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.85);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1001;

        .verify-modal-content {
            background: @card-bg;
            padding: 24px;
            border-radius: 8px;
            width: 380px;
            text-align: center;

            .verify-title {
                font-size: 18px;
                color: @accent-blue;
                margin-bottom: 20px;
                font-weight: 500;
            }

            .verify-footer {
                display: flex;
                justify-content: space-between;
                margin-top: 20px;
                gap: 10px;

                .close-verify-btn,
                .refresh-btn {
                    flex: 1;
                    padding: 8px 16px;
                    border: none;
                    border-radius: 4px;
                    cursor: pointer;
                    font-size: 14px;
                    transition: all 0.2s;
                }

                .close-verify-btn {
                    background: #444;
                    color: @text-primary;

                    &:hover {
                        background: #555;
                    }
                }

                .refresh-btn {
                    background: #0ea5e9;
                    color: white;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 5px;

                    &:hover:not(:disabled) {
                        background: #0284c7;
                    }

                    &:disabled {
                        background: #666;
                        cursor: not-allowed;
                        opacity: 0.6;
                    }
                }
            }
        }

        .drag-verify-container {
            position: relative;
            width: 320px;
            height: 220px;
            margin: 0 auto;
            user-select: none;

            .verify-canvas {
                width: 100%;
                height: 160px;
                border: 1px solid @border-color;
                border-radius: 4px;
                background: #2c2c2c;
                cursor: pointer;
            }

            .slider-track {
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 40px;
                background: #333;
                border: 1px solid @border-color;
                border-radius: 4px;
                margin-top: 10px;
                overflow: hidden;

                .track-bg {
                    width: 100%;
                    height: 100%;
                    background: linear-gradient(90deg, #444 0%, #666 50%, #444 100%);
                }
            }

            .drag-slider {
                position: absolute;
                bottom: 0;
                left: 0;
                width: 40px;
                height: 40px;
                background-color: #3a3a3a;
                border: 2px solid #0ea5e9;
                border-radius: 6px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: grab;
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
                z-index: 10;
                transition: left 0.1s linear;

                &:active {
                    cursor: grabbing;
                }

                .icon {
                    font-size: 20px;
                    color: #0ea5e9;
                }

                &:hover {
                    background-color: #444;
                    transform: scale(1.05);
                }
            }

            .verify-tip {
                position: absolute;
                top: 5px;
                left: 0;
                width: 100%;
                text-align: center;
                font-size: 14px;
                padding: 8px;
                border-radius: 4px;
                z-index: 5;
                background: rgba(0, 0, 0, 0.7);

                &.success {
                    color: #00b42a;
                }

                &.error {
                    color: #ff4d4f;
                }
            }
        }
    }

    .page-title {
        font-size: 20px;
        font-weight: 500;
        margin-bottom: 20px;
        padding-bottom: 10px;
        border-bottom: 1px solid @border-color;
    }

    .info-section {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .success-toast {
        position: fixed;
        top: 20px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 9999;
        background-color: rgba(34, 197, 94, 0.9);
        color: white;
        padding: 12px 20px;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
        animation: fadeInUp 0.3s ease;

        .toast-content {
            display: flex;
            align-items: center;
            gap: 8px;
        }

        .success-icon {
            font-size: 18px;
            font-weight: bold;
            display: inline-block;
            width: 20px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            background: white;
            color: @accent-green;
            border-radius: 10%;
        }

        .success-text {
            font-size: 14px;
        }
    }

    .loading-container {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 40px;
        gap: 10px;

        .loading-spinner {
            width: 24px;
            height: 24px;
            border: 3px solid @accent-blue;
            border-top: 3px transparent;
            border-radius: 10%;
            animation: spin 1s linear infinite;
        }

        .loading-text {
            font-size: 14px;
            color: @text-secondary;
        }
    }

    // 审核中卡片样式
    .review-card {
        background-color: @card-bg;
        border: 1px solid @accent-yellow;
        border-radius: 8px;
        padding: 20px;
        box-sizing: border-box;
        max-width: 600px;
        animation: fadeIn 0.5s ease;

        .card-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 12px;
            margin-bottom: 20px;
            padding-bottom: 10px;
            border-bottom: 1px solid @border-color;

            .card-title {
                font-size: 18px;
                font-weight: 500;
                color: @accent-yellow;
            }

            .review-status {
                padding: 4px 12px;
                background: rgba(245, 158, 11, 0.2);
                border: 1px solid @accent-yellow;
                border-radius: 20px;
                font-size: 12px;
                color: @accent-yellow;
            }
        }

        .card-body {
            display: flex;
            flex-direction: column;
            gap: 12px;

            .auth-item {
                font-size: 14px;
                display: flex;
                align-items: center;
                gap: 8px;

                .label {
                    color: @text-secondary;
                    min-width: 140px;
                }

                .value {
                    color: @text-primary;
                    font-weight: 400;

                    &.review-text {
                        color: @accent-yellow;
                    }
                }
            }
        }
    }

    // 认证成功卡片
    .auth-card {
        background-color: @card-bg;
        border: 1px solid @accent-green;
        border-radius: 8px;
        padding: 20px;
        box-sizing: border-box;
        max-width: 600px;
        animation: fadeIn 0.5s ease;

        .card-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 12px;
            margin-bottom: 20px;
            padding-bottom: 10px;
            border-bottom: 1px solid @border-color;

            .card-title {
                font-size: 18px;
                font-weight: 500;
                color: @accent-green;
            }
        }

        .card-body {
            display: flex;
            flex-direction: column;
            gap: 12px;

            .auth-item {
                font-size: 14px;
                display: flex;
                align-items: center;
                gap: 8px;

                .label {
                    color: @text-secondary;
                    min-width: 140px;
                }

                .value {
                    color: @text-primary;
                    font-weight: 400;

                    &.success-text {
                        color: @accent-green;
                    }

                    &.error-text {
                        color: @error-color;
                    }

                    &.loading-text {
                        color: #0ea5e9;
                    }
                }

                .edit-invoice-text {
                    margin-left: 8px;
                    color: @accent-blue;
                    font-size: 13px;
                    cursor: pointer;

                    &.disabled {
                        color: #666;
                        cursor: not-allowed;
                    }

                    &:hover:not(.disabled) {
                        text-decoration: underline;
                    }
                }
            }
        }
    }

    .auth-form-card {
        background-color: @card-bg;
        border-radius: 8px;
        padding: 20px;
        box-sizing: border-box;
        border: 1px solid @border-color;
        max-width: 600px;

        .form-header {
            margin-bottom: 20px;

            .form-title {
                font-size: 18px;
                font-weight: 500;
                margin-bottom: 5px;
                color: @accent-blue;
            }

            .form-desc {
                font-size: 14px;
                color: @text-secondary;
            }
        }

        .auth-form {
            display: flex;
            flex-direction: column;
            gap: 18px;
        }

        .form-group {
            display: flex;
            flex-direction: column;
            gap: 8px;

            .form-label {
                font-size: 14px;
                display: flex;
                align-items: center;

                .required {
                    color: @error-color;
                    margin-left: 3px;
                }
            }

            .form-input,
            .form-select {
                width: 100%;
                padding: 10px 12px;
                background-color: @input-bg;
                border: 1px solid @border-color;
                border-radius: 4px;
                color: @text-primary;
                font-size: 14px;
                box-sizing: border-box;

                &:focus {
                    outline: none;
                    border-color: @accent-blue;
                }

                &:disabled {
                    background-color: #444;
                    cursor: not-allowed;
                    opacity: 0.8;
                }
            }

            .form-hint {
                font-size: 12px;
                color: @text-secondary;
                margin-top: -4px;
            }

            .error-tip {
                font-size: 12px;
                color: @error-color;
                margin-top: -4px;
            }
        }

        // 图片上传样式
        .upload-box {
            position: relative;

            input[type="file"] {
                position: absolute;
                width: 0;
                height: 0;
                opacity: 0;
                z-index: -1;
            }

            .upload-btn {
                display: inline-block;
                padding: 10px 16px;
                background: @input-bg;
                border: 1px dashed @border-color;
                border-radius: 4px;
                color: @text-secondary;
                cursor: pointer;
                text-align: center;
                transition: all 0.2s;

                &:hover {
                    border-color: @accent-blue;
                    color: @accent-blue;
                }

                .upload-success {
                    color: @accent-green;
                }
            }
        }

        // 单选框组样式
        .radio-group {
            display: flex;
            gap: 20px;
            align-items: center;
        }

        .radio-label {
            display: flex;
            align-items: center;
            gap: 6px;
            cursor: pointer;
            font-size: 14px;

            input[type="radio"] {
                width: 16px;
                height: 16px;
                cursor: pointer;
            }
        }

        .agreement-group {
            flex-direction: row;
            align-items: center;
            gap: 8px;
            margin-top: 10px;

            .agreement-wrapper {
                display: flex;
                align-items: center;
                cursor: default;
                width: 100%;
            }

            .agreement-checkbox {
                appearance: none;
                -webkit-appearance: none;
                width: 16px;
                height: 16px;
                border: 1px solid #0ea5e9;
                border-radius: 2px;
                background-color: #333;
                cursor: pointer;
                position: relative;
                margin-right: 6px;

                &:checked {
                    background-color: #0ea5e9;
                    border-color: #0ea5e9;
                }

                &:checked::after {
                    content: "✓";
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    color: #ffffff;
                    font-size: 12px;
                    line-height: 1;
                    font-weight: bold;
                }

                &:disabled {
                    border-color: #666;
                    background-color: #444;
                    cursor: not-allowed;
                }

                &:disabled:checked::after {
                    color: #aaa;
                }
            }

            .agreement-text {
                color: @text-primary;
                cursor: pointer;
                margin-right: 5px;
            }

            .agreement-link {
                color: @accent-blue;
                text-decoration: underline;
                cursor: pointer;
            }
        }

        .form-actions {
            display: flex;
            justify-content: flex-end;
            margin-top: 10px;

            .btn-submit {
                padding: 10px 20px;
                border-radius: 4px;
                font-size: 14px;
                cursor: pointer;
                transition: all 0.2s;
                border: none;
                background-color: @accent-blue;
                color: white;

                &:hover {
                    background-color: #0284c7;
                }

                &:disabled {
                    background-color: #666;
                    cursor: not-allowed;
                }
            }
        }
    }
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translate(-50%, -20px);
    }

    to {
        opacity: 1;
        transform: translate(-50%, 0);
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}
</style>